<template>
    <div class="wrapper">
      <div class="header">
        <div class="header-left" >
          <span style="display:inline-block;height:100%" @click="toCity">{{townStreet? townStreet:'虎门镇'}}<span class="iconfont iconxiala"></span></span>
            
        </div>
        <div class="header-center">
            <img class="header-center-img" src="../../common/imgs/logo_top_2018.png" alt="">
        </div>
        <div class="header-right">
           <!-- <span class="iconfont iconziyuan"></span>客服 -->
        </div>
     </div>
     <!-- 轮播图 -->
     <div class="swiper">
        <swiper :options="swiperOption">
            <swiper-slide v-for="(item,index) in BannerList" :key="index">
                <img :src="item.Url" alt="">
            </swiper-slide>
         <div class="swiper-pagination"  slot="pagination"></div>
        </swiper>
     </div>
     <!-- 内容 -->
     <div class="icon">
         <div class="icon-item" v-for="(item,index) in TopButtonList" :key="index" @click="toDetails(item.Link,item.LinkType)">
             <div class="grids-icon">
                 <img :src="item.Url" alt="">
             </div>
             <div class="grids-txt">{{item.Name}}</div>
         </div>
         
     </div>
     <!--快洁到家-->
     <div class="content">
         <div class="titleImg">
             <img src="http://www.lungchuenjz.cn/upload/images/index2/floor/h23.png" alt="">
         </div>
         <div class="contentIcon">
          <div class="iconItem" v-for="(item,index) in MainButtonList" :key='index' @click="toMore" v-if='item.Name === "更多"' >
              <div class="grids-icon">
                 <img :src="item.Url" alt="">
             </div>
             <div class="grids-txt">{{item.Name}}</div>
          </div>
           <div class="iconItem" v-else @click="toDetails(item.Link,item.LinkType)">
              <div class="grids-icon">
                 <img :src="item.Url" alt="">
             </div>
             <div class="grids-txt">{{item.Name}}</div>
          </div>
         </div>
     </div>
     <!--底部-->
     <div class="footer">
        <ul>
            <li>
                <router-link to="/" replace>
                <span>首页</span>
                </router-link>
            </li>
            
            <li>
        <router-link to="/join" replace>
          <span>加入我们</span>
        </router-link>
        </li>
            <li @click="goToProfile">
              <!-- <router-link to="/profile" replace> -->
                <span>个人中心</span>
              <!-- </router-link> -->
        </li>
        </ul>
      <div class="footerWord">
        <div>保姆、月嫂专线：
          <a href="tel:0769-82899991">
          <span>0769-82899991</span>
          </a>
        </div>
        <div>保洁、空气净化热线：
          <a href="tel:4001500600">
          <span>4001 500 600</span>
          </a>
        </div>
			  <div>©2018 广东合创快洁到家家政服务有限公司版权所有</div>
        <div><a href="https://beian.miit.gov.cn/"><span>粤ICP备16099253号</span></a></div>
	  </div>
     </div>
     <!-- 空元素 -->
        <div class="nothing"></div>
      <!-- loading -->
      <div class="loading" v-if="isLoading">
          <van-loading color="#1989fa" size="80px"/>
      </div>
    </div>   
</template>

<script>
import {mapState} from 'vuex'
import { Toast } from 'vant'
export default {
    data(){
        return {
            swiperOption:{
             pagination: {
            el: '.swiper-pagination'
            },
            loop: true,
            autoplay: 5000
        },
        BannerList:[],
        TopButtonList:[],
        MainButtonList:[],
        isLoading:true
        }
       
    },
    computed: {
      ...mapState(['townStreet'])
    },
    mounted () {
        // 获取数据
        this.$axios.get('/api/DjOrder/GetIndexInfo').then(this.getIndexInfo).catch(() => { this.isLoading = false } )
        //删除登录前路径
        this.cookieUtil.delCookie('loginPath')
        localStorage.removeItem('loginPath')
    },
    methods: {
        getIndexInfo (res) {
           //console.log(res.data)
          /* if (process.env.NODE_ENV === "development"){
           // console.log(res.data)
           let data = res.data
            this.BannerList = data.BannerList.map((i) => {
                i.Url = 'http://168.128.86.250' + i.Url
                return i
            })
            this.TopButtonList = data.TopButtonList.map((i) => {
                i.Url = 'http://168.128.86.250' + i.Url
                return i
            })
            this.MainButtonList =  data.MainButtonList.map((i) => {
                i.Url = 'http://168.128.86.250' + i.Url
                return i
            })
          } */
          let data = res.data
         //console.log(data)
          this.BannerList = data.BannerList

          if (process.env.NODE_ENV === "development"){

           this.TopButtonList = data.TopButtonList.map((i) => {
                i.Url = 'https://www.lungchuenjz.cn' + i.Url
                return i
            })
           this.MainButtonList =  data.MainButtonList.map((i) => {
                i.Url = 'https://www.lungchuenjz.cn' + i.Url
                return i
            })

          }else{
            this.TopButtonList = data.TopButtonList
            this.MainButtonList =  data.MainButtonList
          }
          this.isLoading = false
        },
        toMore () {
            this.$router.push('/more')
        },
        toDetails (Link,LinkType) {
          if(LinkType == 'NotLink'){
            console.log('不跳转')
            return
          }else if(LinkType == 'ToUrl'){
            this.$router.push(Link)
          }else if(LinkType == 'ShowTips'){
            Toast(Link);
          }
          
        },
        toCity () {
          this.$router.push('/city')
        },
        goToProfile(){
          if(localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')){
              this.$router.push('/profile')
          }else{

              this.$router.push('/wxlogin')
          }
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper
 background: #F5F5F5
 .header
   display: flex
   width:  100%
   height: 40px
   justify-content: space-between
   background: white
   .header-left
     margin-top: 12px
     margin-left: 6px
     color: #009933
     width: 33.33%
   .header-center
    width: 33.33%
    &>img
      width 100%
      height 100%
    .header-center-img
      height: 35px
   .header-right
     display: flex
     flex-direction: column
     margin-top: 4px
     margin-right: 6px
     font-size: 12px
     width: 33.33%
     
  .swiper
   width: 100%
   background: white
   & img
    width: 100%
  .icon
   display: flex
   width: 100%
   background: white
   .icon-item
     display: flex
     flex-direction: column
     justify-content: center
     align-items: center
     width: 25%
     border-right: 1px solid #eee
     padding: 8px 0
     font-size: 12px
     &:last-child
      border: none
     .grids-icon
      width: 45px
      height: 45px
      margin-bottom: 8px
      & > img
       width: 100%
  .content
    width: 100%
    margin-top: 10px
    background: white
    .titleImg
     width: 100%
     background: #D3F8F2
     & img 
      width: 100%
    .contentIcon
      display: flex
      width: 100%
      flex-wrap:wrap
      .iconItem
       width: 25%
       display: flex
       flex-direction: column
       justify-content: center
       align-items: center
       margin: 20px 0
       font-size: 12px
       .grids-icon
        width: 45px
        height: 45px
        &>img
         width: 100%
       .grids-txt
         margin-top: 8px
 .footer
   width: 100%
   margin-top: 10px
   padding: 10px 0
   background: white
   color: #333
   &>div
    line-height: 1.6
   & a
    color: #333
   &>ul
    list-style: none
    display: flex
    justify-content: space-around
    margin-bottom: 12px
    &>li
     width: 33.33%
     text-align: center
     font-size: 12px
     border-right: 1px solid
     &:last-child
      border: none
  .footerWord
    font-size: 12px
    text-align: center
    &>p
     margin: 5px 0
 .nothing
  height: 50px
  background #ffffff
 .loading
    width: 300px;
    height: 300px;
    position:absolute;
    left:50%;
    top:50%;
    transform:translate(-50%,-50%);
    display: flex;
    justify-content: center;
    align-items: center;
     
</style>



// WEBPACK FOOTER //
// src/pages/Home/Home.vue